/**
 * @generated SignedSource<<aeb0717d4439b485c9801d46a1715b5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RevenueRecognitionLoader_viewer$data = {
  readonly id: string;
  readonly company: {
    readonly currency: string | null;
  } | null;
  readonly project: {
    readonly rateCard: {
      readonly currency: string | null;
    } | null;
    readonly aggregatedFinancialNumbers: ReadonlyArray<string | null>;
    readonly financialNumbers: {
      readonly recognitionAmount: number | null;
      readonly estimatedCost: number | null;
      readonly recognitionProfit: number | null;
      readonly recognitionProfitPercentage: number | null;
    } | null;
    readonly workAggregatedFinancialNumbers?: ReadonlyArray<string | null>;
    readonly workFinancialNumbers?: {
      readonly recognitionAmount: number | null;
    } | null;
    readonly expenseAggregatedFinancialNumbers?: ReadonlyArray<string | null>;
    readonly expenseFinancialNumbers?: {
      readonly billableTotalTimeAndExpensesAtCompletion: number | null;
      readonly allTotalTimeAndExpensesAtCompletion: number | null;
    } | null;
    readonly timeAndMaterialsTimeBreakdown?: ReadonlyArray<{
      readonly year: number | null;
      readonly month: number | null;
      readonly financialNumbers: {
        readonly recognitionAmount: number | null;
      } | null;
    } | null>;
    readonly timeAndMaterialsExpensesBreakdown?: ReadonlyArray<{
      readonly year: number | null;
      readonly month: number | null;
      readonly financialNumbers: {
        readonly billableTotalTimeAndExpensesAtCompletion: number | null;
      } | null;
    } | null>;
    readonly fixedPriceDeliverablesTotalTimeBreakdown?: ReadonlyArray<{
      readonly year: number | null;
      readonly month: number | null;
      readonly financialNumbers: {
        readonly recognitionAmount: number | null;
      } | null;
    } | null>;
    readonly fixedPriceDeliverablesTotalExpensesBreakdown?: ReadonlyArray<{
      readonly year: number | null;
      readonly month: number | null;
      readonly financialNumbers: {
        readonly billableTotalTimeAndExpensesAtCompletion: number | null;
      } | null;
    } | null>;
    readonly fixedPriceDeliverablesTimeBreakdown?: ReadonlyArray<{
      readonly deliverableId: string | null;
      readonly year: number | null;
      readonly month: number | null;
      readonly financialNumbers: {
        readonly recognitionAmount: number | null;
      } | null;
    } | null>;
    readonly fixedPriceDeliverablesExpensesBreakdown?: ReadonlyArray<{
      readonly deliverableId: string | null;
      readonly year: number | null;
      readonly month: number | null;
      readonly financialNumbers: {
        readonly billableTotalTimeAndExpensesAtCompletion: number | null;
      } | null;
    } | null>;
  } | null;
  readonly " $fragmentType": "RevenueRecognitionLoader_viewer";
};
export type RevenueRecognitionLoader_viewer$key = {
  readonly " $data"?: RevenueRecognitionLoader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"RevenueRecognitionLoader_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  }
],
v1 = {
  "kind": "Literal",
  "name": "addAccumulatedNumbers",
  "value": true
},
v2 = {
  "kind": "Variable",
  "name": "aggregateLevel",
  "variableName": "aggregateLevel"
},
v3 = {
  "kind": "Variable",
  "name": "aggregates",
  "variableName": "aggregates"
},
v4 = {
  "kind": "Literal",
  "name": "convertToProjectCurrency",
  "value": true
},
v5 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v6 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v7 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v8 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v9 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v10 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recognitionAmount",
  "storageKey": null
},
v12 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "searchQuery"
},
v13 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v12/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/)
],
v14 = [
  (v11/*: any*/)
],
v15 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "expenseSearchQuery"
},
v16 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v15/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billableTotalTimeAndExpensesAtCompletion",
  "storageKey": null
},
v18 = {
  "kind": "Literal",
  "name": "deliverableIdFilterMode",
  "value": "NOT_IN"
},
v19 = {
  "kind": "Literal",
  "name": "groupByDeliverable",
  "value": false
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialNumbers",
  "kind": "LinkedField",
  "name": "financialNumbers",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v23 = [
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialNumbers",
  "kind": "LinkedField",
  "name": "financialNumbers",
  "plural": false,
  "selections": [
    (v17/*: any*/)
  ],
  "storageKey": null
},
v25 = [
  (v20/*: any*/),
  (v21/*: any*/),
  (v24/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deliverableId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "aggregateLevel"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "aggregates"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endYear"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "expenseAggregates"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "expenseSearchQuery"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hasDeliverables"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hasExpenses"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchQuery"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startYear"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "RevenueRecognitionLoader_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "internalId",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RateCard",
          "kind": "LinkedField",
          "name": "rateCard",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/)
          ],
          "kind": "ScalarField",
          "name": "aggregatedFinancialNumbers",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/)
          ],
          "concreteType": "FinancialNumbers",
          "kind": "LinkedField",
          "name": "financialNumbers",
          "plural": false,
          "selections": [
            (v11/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "estimatedCost",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "recognitionProfit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "recognitionProfitPercentage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "condition": "hasExpenses",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "workAggregatedFinancialNumbers",
              "args": [
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                (v7/*: any*/),
                (v12/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/),
                (v10/*: any*/)
              ],
              "kind": "ScalarField",
              "name": "aggregatedFinancialNumbers",
              "storageKey": null
            },
            {
              "alias": "workFinancialNumbers",
              "args": (v13/*: any*/),
              "concreteType": "FinancialNumbers",
              "kind": "LinkedField",
              "name": "financialNumbers",
              "plural": false,
              "selections": (v14/*: any*/),
              "storageKey": null
            },
            {
              "alias": "expenseAggregatedFinancialNumbers",
              "args": [
                (v1/*: any*/),
                (v2/*: any*/),
                {
                  "kind": "Variable",
                  "name": "aggregates",
                  "variableName": "expenseAggregates"
                },
                (v4/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                (v7/*: any*/),
                (v15/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/),
                (v10/*: any*/)
              ],
              "kind": "ScalarField",
              "name": "aggregatedFinancialNumbers",
              "storageKey": null
            },
            {
              "alias": "expenseFinancialNumbers",
              "args": (v16/*: any*/),
              "concreteType": "FinancialNumbers",
              "kind": "LinkedField",
              "name": "financialNumbers",
              "plural": false,
              "selections": [
                (v17/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "allTotalTimeAndExpensesAtCompletion",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ]
        },
        {
          "condition": "hasDeliverables",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "timeAndMaterialsTimeBreakdown",
              "args": [
                (v4/*: any*/),
                (v18/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                (v7/*: any*/),
                (v19/*: any*/),
                (v12/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/),
                (v10/*: any*/)
              ],
              "concreteType": "DeliverableRevenueRecognitionBreakdown",
              "kind": "LinkedField",
              "name": "deliverableRevenueRecognitionBreakdown",
              "plural": true,
              "selections": (v23/*: any*/),
              "storageKey": null
            },
            {
              "alias": "timeAndMaterialsExpensesBreakdown",
              "args": [
                (v4/*: any*/),
                (v18/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                (v7/*: any*/),
                (v19/*: any*/),
                (v15/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/),
                (v10/*: any*/)
              ],
              "concreteType": "DeliverableRevenueRecognitionBreakdown",
              "kind": "LinkedField",
              "name": "deliverableRevenueRecognitionBreakdown",
              "plural": true,
              "selections": (v25/*: any*/),
              "storageKey": null
            },
            {
              "alias": "fixedPriceDeliverablesTotalTimeBreakdown",
              "args": [
                (v4/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                (v7/*: any*/),
                (v19/*: any*/),
                (v12/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/),
                (v10/*: any*/)
              ],
              "concreteType": "DeliverableRevenueRecognitionBreakdown",
              "kind": "LinkedField",
              "name": "deliverableRevenueRecognitionBreakdown",
              "plural": true,
              "selections": (v23/*: any*/),
              "storageKey": null
            },
            {
              "alias": "fixedPriceDeliverablesTotalExpensesBreakdown",
              "args": [
                (v4/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                (v7/*: any*/),
                (v19/*: any*/),
                (v15/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/),
                (v10/*: any*/)
              ],
              "concreteType": "DeliverableRevenueRecognitionBreakdown",
              "kind": "LinkedField",
              "name": "deliverableRevenueRecognitionBreakdown",
              "plural": true,
              "selections": (v25/*: any*/),
              "storageKey": null
            },
            {
              "alias": "fixedPriceDeliverablesTimeBreakdown",
              "args": (v13/*: any*/),
              "concreteType": "DeliverableRevenueRecognitionBreakdown",
              "kind": "LinkedField",
              "name": "deliverableRevenueRecognitionBreakdown",
              "plural": true,
              "selections": [
                (v26/*: any*/),
                (v20/*: any*/),
                (v21/*: any*/),
                (v22/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": "fixedPriceDeliverablesExpensesBreakdown",
              "args": (v16/*: any*/),
              "concreteType": "DeliverableRevenueRecognitionBreakdown",
              "kind": "LinkedField",
              "name": "deliverableRevenueRecognitionBreakdown",
              "plural": true,
              "selections": [
                (v26/*: any*/),
                (v20/*: any*/),
                (v21/*: any*/),
                (v24/*: any*/)
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "18770d52c5ca1024a2793e31d5d80442";

export default node;
